<template>
  <v-chip
    v-if="enabled"
    color="deep-purple accent-2"
    small
    label
    dark
    class="auto-extension-badge font-weight-bold"
  >
    <v-icon
      left
      x-small
    >
      {{ icons.mdiAutorenew }}
    </v-icon>
    自動延長
  </v-chip>
</template>

<script>
import { mdiAutorenew } from '@mdi/js'

export default {
  props: {
    // 自動延長が有効な卓（会計まで何度でも自動延長する）。
    // 複数回延長するため「済」状態は持たず、ONの間つねに「自動延長」を表示する。
    enabled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      icons: { mdiAutorenew },
    }
  },
}
</script>
